<div id="donors" style="display:none;margin-top: 3rem;">
    <app-header title=""></app-header>
    <div class="px-5 pt-4">
        <div class="row custom-material-form updated-dropdown">
            <div class="col" id="donorsStartDateCol">
                <div class="md-form">
                    <input placeholder="Start donation date" type="text" id="donorsStartDatePicker" class="form-control datepicker" style="cursor: pointer;">
                    <label id="donorsStartDatePickerLabel" for="donorsStartDatePicker">Start Donation Date</label>
                    <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('donorsStartDatePicker').focus()" style="cursor:pointer"></i>
                </div>
            </div>
            <div class="col" id="donorsEndDateCol">
                <div class="md-form">
                    <input placeholder="End donation date" type="text" id="donorsEndDatePicker" class="form-control datepicker" style="cursor: pointer;">
                    <label id="donorsEndDatePickerLabel" for="donorsEndDatePicker">End Donation Date</label>
                    <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('donorsEndDatePicker').focus()" style="cursor:pointer"></i>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-check md-form">
                    <input type="checkbox" class="form-check-input filled-in" id="allDonorsReport">
                    <label  class="form-check-label" for="allDonorsReport">Show all donors, include donors with no donations.</label>
                </div>
            </div>
            <div class="col text-right">
                <button id="sendReceiptToAll" type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap" aria-expanded="false">
                    <i class="fas fa-comments mr-2"></i>Send 2024 Annual Receipts
                </button>
                <div class="body-3 bold" id="receiptLastSentOn"></div>
            </div>
        </div>

        <div class="table--paybee">
            <table id ="donorList" class="table" cellspacing="0" style="width: 100%;">
                <thead class="thead-light">
                <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Address</th>
                    <th>ExternalId</th>
                    <th>Amount</th>
                    <th>Donations</th>
                    <th>Last</th>
                    <th class="no-export"></th>
                </tr>
                </thead>
            </table>
        </div>
    </div>
</div>